import PropTypes from "prop-types";
import React from "react";
import { FormInputGroup } from "../../../react/form_input_group";
import { formatCurrency } from "../../utilities.js";
import { CartItem } from "./cart_item";
import { CartRow } from "./cart_row";

export const Cart = ({
  items = [],
  fee,
  feeLabel = 'Fees',
  tax,
  total,
  currency,
  showTaxMessage = false,
  onItemPriceChange
}) => {
  return (
    <FormInputGroup>
      {items.map((item) => (
        <CartItem
          item={item}
          key={item.ticket_class_id}
          currency={currency}
          onItemPriceChange={onItemPriceChange}
        />
      ))}

      {fee > 0 && (
        <CartRow
          label={feeLabel}
          right={formatCurrency(fee, currency)}
        />
      )}
      {tax > 0 && (
        <CartRow
          label="Tax"
          right={formatCurrency(tax, currency)}
        />
      )}
      {showTaxMessage && (
        <CartRow
          label="Tax"
          right="Calculated at next step"
        />
      )}

      {total > 0 && (
        <CartRow
          label="TOTAL"
          right={formatCurrency(total, currency)}
        />
      )}
    </FormInputGroup>
  );
};

Cart.propTypes = {
  items: PropTypes.array,
  fee: PropTypes.number,
  total: PropTypes.number,
  currency: PropTypes.string,
  onItemPriceChange: PropTypes.func,
};
